import { Button, Grid, Typography } from "@mui/material";

import { FairPaySurveyResponse } from "features/FairPaySurvey/schemas";
import { trackEvent } from "utils/tracking";

const styles = {
  badge: {
    my: 2,
    background: "linear-gradient(to bottom, #151F16, #042924)",
    p: 2,
    borderRadius: "20px",
  },
  chip: {
    py: 1,
    px: 2,
    mb: 1,
    fontWeight: 700,
    fontSize: "18px",
    color: "#F7EE6F",
    borderRadius: "20px",
    border: `1px solid #F7EE6F`,
  },
  badgeText: {
    textAlign: "center",
    display: "flex",
    gap: 1,
    alignItems: "center",
    mt: -2,
  },
  highlightNumber: {
    fontSize: "68px",
    fontWeight: 600,
    color: "white",
  },
  outOf100: {
    fontSize: "68px",
    fontWeight: 600,
    color: "rgba(220, 217, 174, 0.16)",
  },
  slash: {
    fontSize: "84px",
    fontWeight: 400,
    color: "rgba(220, 217, 174, 0.16)",
  },
  descriptionText: { color: "white", textAlign: "center", maxWidth: "70%" },
  descriptionLargerText: {
    color: "white",
    textAlign: "center",
    maxWidth: "70%",
    fontSize: "18px",
  },
  button: {
    px: 3,
    py: 2,
    textTransform: "none",
    backgroundColor: "white",
    borderRadius: 20,
    fontWeight: 600,
    fontSize: "18px",
    my: 1,
  },
};

export default function FairPayBadge({
  surveyResponse,
}: {
  surveyResponse: FairPaySurveyResponse | null;
}) {
  if (!surveyResponse) {
    return null;
  }

  if (!surveyResponse?.employmentTypePercentile) {
    return null;
  }

  let paragraphRes = "As a ";
  if (surveyResponse.employmentType === "part-time") {
    paragraphRes += "🌙 part-time creator, ";
  } else {
    paragraphRes += "⚡ full-time creator, ";
  }
  paragraphRes += `you're in the top ${
    100 - Math.round(surveyResponse.employmentTypePercentile) || 1
  }% of creators - `;
  if (surveyResponse.employmentTypePercentile >= 80) {
    paragraphRes += `congrats on being a top earner!`;
  } else if (surveyResponse.employmentTypePercentile >= 50) {
    paragraphRes += `strong work!`;
  } else {
    paragraphRes += `you're on your way up!`;
  }

  const handleShare = async () => {
    trackEvent("Fair Pay - Share Your Score Clicked", {
      "Survey UUID": surveyResponse.surveyUuid,
    });
    try {
      if (navigator.canShare && navigator.canShare({ text: "hi" })) {
        await navigator.share({
          text: "I just got my Creator Fair Pay Score from Bento! It told me how my creator earnings compare to my peers. Get yours too at onbento.com/fairpay",
        });
      }
    } catch {}
  };

  return (
    <Grid item xs={12} justifyContent="center" container sx={styles.badge}>
      <Typography component="div" sx={styles.chip}>
        Your Fair Pay Score
      </Typography>
      <Grid item xs={12} justifyContent="center" container>
        <Typography sx={styles.descriptionText}>
          We analyzed your creator earnings compared to creators like you.
        </Typography>
      </Grid>{" "}
      <Typography sx={styles.badgeText}>
        <Typography component="span" sx={styles.highlightNumber}>
          {Math.round(surveyResponse.employmentTypePercentile)}
        </Typography>
        <Typography component="span" sx={styles.slash}>
          {" "}
          /{" "}
        </Typography>
        <Typography component="span" sx={styles.outOf100}>
          100
        </Typography>
      </Typography>
      <Typography sx={styles.descriptionLargerText} paragraph>
        {paragraphRes}
      </Typography>
      <Button
        variant="contained"
        color="secondary"
        sx={styles.button}
        onClick={handleShare}
      >
        Share Your Score
      </Button>
    </Grid>
  );
}
